import { CONFIG } from '../core/config.mjs';

/**
 * Évalue qualité connexion réseau
 */
export function getConnectionQuality() {
    const result = { isGoodEnough: true, shouldReduceQuality: false };

    if ('connection' in navigator && navigator.connection.effectiveType) {
        const type = navigator.connection.effectiveType;
        const ranks = { 'slow-2g': 1, '2g': 2, '3g': 3, '4g': 4 };
        const currentRank = ranks[type] || 4;
        const minRank = ranks[CONFIG.growth.minConnection] || 3;

        result.isGoodEnough = currentRank >= minRank;
        result.shouldReduceQuality = currentRank <= 2;
    }

    return result;
}
